/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SettingManagementListSettingResponse } from './SettingManagementListSettingResponse';

export type SettingManagementListSettingResponseApiRespoonse = {
    data?: SettingManagementListSettingResponse;
    status?: SettingManagementListSettingResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace SettingManagementListSettingResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

